<meddata-header></meddata-header>
<meddata-sidebar></meddata-sidebar>
<meddata-right-sidebar></meddata-right-sidebar>
<router-outlet></router-outlet>